import * as SolidIcons from "@heroicons/react/24/solid";
import { StyledIcon } from "styled-components/Common/CommonStyled";

const DynamicHeroIcon = ({ name, className }: { name: string; className?: string }) => {
	const IconComponent = (SolidIcons as any)[name];

	if (!IconComponent) {
		return null;
	}

	return (
		<StyledIcon size={22}>
			<IconComponent className={className} />
		</StyledIcon>
	);
};

export default DynamicHeroIcon;
